// api
export const WSS_URL = (import.meta.env.VITE_WSS_URL ?? "").replace(/\/+$/, "");

export const API_BASE_URL = (import.meta.env.VITE_API_URL ?? "").replace(/\/+$/, "");

// The marketing site (docs, legal pages, homepage sections) — was hardcoded as
// "https://cronika.com" in several places; now configurable per environment.
export const LANDING_URL = (import.meta.env.VITE_APP_URL ?? "https://cronika.com").replace(/\/+$/, "");

// Math
export const MAX_PRECISION = 80;

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

// export const IMAGES_URL = DEV_MODE ? '' : CDN_URL
export const IMAGES_URL = "";

export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID ?? "";

export const IS_MAINTENANCE_ENABLED = import.meta.env.VITE_IS_MAINTENANCE_ENABLED === "true";

export const GOOGLE_CLIENT_ID: string = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "";
